import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";
import AsyncSelect from "react-select/lib/Async";
import classnames from "classnames";

class DigiFormLocations extends React.Component {
	state = {
    loading: false,
    locationsToSelect: [],
    selectedLocations: this.props.value
  };

  componentWillMount() {
    axios.get("/locations.json")
      .then((resp) => {
        this.setState({ locationsToSelect: resp.data });
      })
    ;
  }

  componentWillReceiveProps(newProps) {
    if(this.props != newProps) {
      this.setState({
        fieldErrors: newProps.fieldErrors
      });
    }
  }

  render() {
    const {
      loading,
      locationsToSelect,
      selectedLocations
    } = this.state;

    const locationsToSelectFormatted = locationsToSelect.map(location => ({
      value: location.id,
      label: location.name
    }));

    const {
      label,
      required,
      fieldErrors
    } = this.props;
		return (
			<div>
        <div
          className={classnames("form-group", {
            "has-error": fieldErrors && fieldErrors.length > 0
          })}
        >
          {label ? (
            <label
              className="control-label word-wrap"
              htmlFor={`select${name}`}
              id="digi-form-locations-label"
            >
              {label}
              {required ? " *" : ""}
            </label>
          ) : null}
          <AsyncSelect
            isMulti={true}
            aria-labelledby="digi-form-locations-label"
            cacheOptions
            className="custom-react-select"
            value={this.state.selectedLocations.filter(location => location._destroy !== true)}
            defaultOptions={locationsToSelectFormatted}
            loadOptions={this.loadOptions}
            onChange={this.handlerChangeLocations}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: "#666666", 
              })
            }}
          />

          {fieldErrors ? (
            <span className="help-block">{fieldErrors.join(", ")}</span>
          ) : null}
        </div>
			</div>
		);
	}


  handlerChangeLocations = newLocations => {
    const selectedLocations = this.state.selectedLocations;
    // Add a new location
    newLocations.forEach(location => {
      const idx = lodash.findIndex(selectedLocations, { value: location.value });
      if (idx === -1) {
        selectedLocations.push({
          value: location.value,
          location_id: location.value,
          label: location.label
        });
      }
    });

    // Remove a new location or remove a selected location
    selectedLocations.forEach((location, index) => {
      const idx = lodash.findIndex(newLocations, { value: location.value });
      if (idx === -1) {
        if (location.id) {
          location._destroy = true;
        } else {
          selectedLocations.splice(index, 1);
        }
      }
    });

    this.setState({ selectedLocations: selectedLocations, fieldErrors: {} });
    this.props.onChange(selectedLocations, this.props.associationName);
  };

  buildDataResult = (locations, selectedLocationsIds) => {
    return locations.filter(location => !selectedLocationsIds.includes(location.id)).map(location => {
      return {
        value: location.id.toString(),
        label: location.name
      };
    });
  };

  loadOptions = inputValue => {
    const urlSearch = "/locations.json?search={q}";

    const url = urlSearch.replace("{q}", encodeURIComponent(inputValue));
    return axios.get(url).then(resp => this.buildDataResult(
      resp.data, this.state.selectedLocations.map(l => l.id)
    ));
  };
}

export default DigiFormLocations;
